/**
 * Localization module.
 */

import Jed from 'jed';
import _ from 'underscore';
import $ from 'jquery';
import P from 'bluebird';

let jed;

/**
 * Function content localization.
 *
 * @param {String} str Input string from .pot file.
 * @returns {String} Translated string or input string, if translation was not found.
 */
let gettext = function (str) {
  return jed.translate(str).fetch();
};

function normalizedLanguage() {
  let lang = localStorage.getItem('locale') || navigator.language;
  lang = lang == 'root' ? 'en' : lang;
  let extMatch = lang.match(/([a-z]{2})-.+/); // Try to match for extended representation (like, en-GB).

  if (extMatch) {
    return extMatch[1];
  }

  return lang;
}

gettext.i18nInitD = new P(
  (resolve, reject) => {
    let locale = normalizedLanguage();
    locale = locale == 'en' ? 'root' : locale;

    return import(`nls/${locale}/messages.po`).then(
      nls => {
        jed = new Jed(nls.default);
        resolve();
      },
      () => {
        return import(`nls/root/messages.po`).then(nls => {
          jed = new Jed(nls.default);
          resolve();
        });
      }
    );
  },
  () => {}
);

/**
 * Plural version of gettext.
 *
 * @param {String} str Singular form of key.
 * @param {String} plural Plural form of key.
 * @param {Number} num The values of plural.
 * @returns {String} Translated string.
 */
gettext.ngettext = function (str, plural, num) {
  return jed.ngettext(str, plural, num);
};

// Make function global for templates.
window.gettext = gettext;

// Perform localization in HTML elements with 'data-gettext' attribute.
gettext.i18nInitD.then(() => {
  $('[data-gettext]').each(function () {
    let $el = $(this);
    let field = $el.data('gettext');

    if (field == 'html') {
      $el.html(_.template($el.text())());
    } else if (field.match(/^html\+/)) {
      $el.html(_.template($el.text())());

      let attr = field.substr('html+'.length);

      $el.attr(attr, _.template($el.attr(attr))());
    } else {
      $el.attr(field, _.template($el.attr(field))());
    }

    $el.removeClass('gettext-hide');
  });
});

export default gettext;
